var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWithXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.571 1v3.429M10.43 1v3.429M5.2 5.8L8.8 10m0-4.2L7 7.9 5.2 10M1.857 2.714h10.286a.857.857 0 01.857.857v8.572a.857.857 0 01-.857.857H1.857A.857.857 0 011 12.143V3.57a.857.857 0 01.857-.857z"
  })));
}
export default SvgCalendarWithXIcon;